<template>
<div class="page page-center">
    <div class="container-tight py-4">
        <div class="text-center mb-4">
            <router-link :to="{ 'name': 'home' }">
                <span v-html="require('@/assets/img/logo.svg').default" class="main-logo" />
            </router-link>
        </div>
        <form class="card card-md" v-on:submit.prevent="renderCaptcha()">
            <div class="card-body">
                <h2 class="card-title text-center mb-4">Sign up</h2>
                <div class="mb-3" v-show="!verifyCaptcha">
                    <label class="form-label">Name</label>
                    <input type="text" minlength="2" class="form-control" placeholder="Enter name" v-model="name" required />
                </div>
                <div class="mb-3" v-show="!verifyCaptcha">
                    <label class="form-label">Email address</label>
                    <input type="email" class="form-control" placeholder="Enter email" v-model="email" required />
                </div>
                <div class="mb-3" v-show="!verifyCaptcha">
                    <label class="form-check">
                        <input type="checkbox" class="form-check-input" v-model="terms" required />
                        <span class="form-check-label">I agree to the <a href="/terms-of-service" target="_blank">Terms of Service</a></span>
                    </label>
                    <label class="form-check">
                        <input type="checkbox" class="form-check-input" v-model="privacy" required />
                        <span class="form-check-label">I agree with the <a href="/privacy-policy" target="_blank">Privacy Policy</a></span>
                    </label>
                </div>
                <div class="form-footer" v-show="!verifyCaptcha">
                    <div class="buttons">
                        <button type="submit" class="btn btn-primary w-100" :disabled="loading">Register</button>
                    </div>
                </div>

                <div class="text-center">
                    <div id="recaptcha" class="g-recaptcha content-margin" style="display: inline-block;"></div>
                </div>

                <div class="text-secondary mt-3">
                    This site is protected by Turnstile and the Cloudflare Privacy Policy and Terms of Service apply.
                </div>
            </div>
        </form>

        <div class="text-center text-secondary mt-3" v-if="!verifyCaptcha">
            <router-link :to="{ 'name': 'login' }">Sign in</router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ["next"],
    data() {
        return {
            email: "",
            name: "",
            terms: "",
            privacy: "",
            verifyCaptcha: false,
            loading: false
        };
    },
    methods: {
        renderCaptcha() {
            try {
                window.turnstile.render("#recaptcha", {
                    sitekey: "0x4AAAAAAAx4mGerDwz282Av",
                    theme: "light",
                    callback: (token) => {
                        this.handleSend(token);
                    }
                });
                this.verifyCaptcha = true;
            } catch (e) {
                this.flashError(e);
            }
        },
        createRecaptcha() {
            /* this.loading = true;
            this.loading = false; */
            if (window.turnstile) {
                return;
            }
            const script = document.createElement("script");
            script.setAttribute("async", "");
            script.setAttribute("defer", "");
            script.id = "recaptcha-script";
            script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
            document.getElementsByTagName("head")[0].appendChild(script);
        },
        removeRecaptcha() {
            this.verifyCaptcha = false;
            window.turnstile.remove("#recaptcha");
        },
        handleSend(token) {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.$store.dispatch("auth/signup", { email: this.email, name: this.name, terms: this.terms, privacy: this.privacy, token }).then(() => {
                this.flashSuccess("Sign-up success");
                this.$router.push({ name: "code", query: { email: this.email, next: this.next } });
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.loading = false;

                // reset captcha
                window.turnstile.reset("#recaptcha");
                this.removeRecaptcha();

                this.verifyCaptcha = false;
            });
        }
    },
    mounted() {
        this.createRecaptcha();

        this.$store.dispatch("auth/info").then((data) => {
            if (data && data.id) {
                this.$router.push({ name: "home" });
            }
        }).catch(e => {});
    },
    beforeDestroy() {
        this.removeRecaptcha();
    }
};
</script>
